import Vue from 'vue';
import {
  getBudgetSummary as getBudgetSummaryCall,
  getBudgetTransactions as getBudgetTransactionsCall
} from '@/api/budgets';
import { GLOBAL_ERROR } from '@/utils/constants';

/**
 * Get a budget summary for a given lease ID
 *
 * @param commit vuex function to call mutations
 * @param dispatch vuex function to call actions
 * @param state vuex module state
 * @param leaseId ID of the lease to get the budget summary for
 * @returns {Promise<*>}
 */
export function getBudgetSummary({ commit, dispatch, state }, leaseId) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['budgetSummaryLoading', true]);
      commit('clearBudgetTransactions');
      const budgetSummary = await getBudgetSummaryCall(leaseId);
      commit('setBudgetSummary', budgetSummary);
      resolve();
    } catch (err) {
      commit('setState', ['budgetSummaryLoading', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getBudgetSummary')
      });
      return reject();
    }
  });
}

export function getBudgetTransactions(
  { commit, dispatch, state, rootState },
  { budgetCategory, startDate, endDate }
) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['budgetTransactionsLoading', true]);
      const leaseId = rootState.lease.selectedLease.id;
      const transactions = await getBudgetTransactionsCall({
        budgetCategory,
        leaseId,
        startDate,
        endDate
      });
      commit('addBudgetTransactions', transactions);
      resolve();
    } catch (err) {
      commit('setState', ['budgetTransactionsLoading', false]);
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('getBudgetTransactions')
      });
      return reject();
    }
  });
}
